module.exports = __webpack_public_path__ + "img/lucky-draw-instant-prize-custom.7fa87366.webp";